import React from "react";
import styled, { css } from "styled-components";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";

interface ToggleProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	toggled: boolean;
	onChange: (v: boolean) => void;
	disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ toggled, onChange, disabled, ...htmlProps }) => {
	return (
		<Container toggled={toggled} {...htmlProps} disabled={disabled} onClick={() => onChange(!toggled)}>
			<div />
		</Container>
	);
};

const Container = styled(RoundedBlock).withConfig({
	shouldForwardProp: (prop) => !["toggled", "disabled"].includes(prop),
})<{ toggled: boolean; disabled?: boolean }>`
	padding: 2px;
	position: relative;
	width: 42px;
	cursor: pointer;
	border-radius: 11px;
	background-color: ${({ theme, toggled }) => (toggled ? theme.colors.secondary : theme.colors.secondaryLight)};
	transition: background-color 0.2s linear;

	> div {
		width: 17px;
		height: 17px;
		border-radius: 9px;
		background-color: ${({ theme, toggled }) => (toggled ? theme.colors.white : theme.colors.secondary)};
		${({ toggled }) => toggled && "transform: translateX(19px)"};
		transition:
			transform ease-in-out 0.2s,
			background-color linear 0.2s;
	}

	${({ disabled, toggled, theme }) =>
		disabled &&
		css`
			pointer-events: none;
			background-color: ${toggled ? theme.colors.darkgray : theme.colors.white};
			> div {
				background-color: ${toggled ? theme.colors.white : theme.colors.lightgray};
			}
		`}
`;
